// Палитра дашборда «Оценка качества» — производная от корпоративной (scss/_variables.scss).
//
// Композиция (решение владельца продукта, 2026-08-08: «играть цветом, делать акценты,
// использовать полутона»):
// - ГРОМКИЙ цвет один — корповый оранжевый $orange (#f1905b, им же красятся button_orange).
//   Он только у ИНТЕРАКТИВА и выделений: активный год, подчёркивание вкладки. Массовые
//   активные состояния (12 выбранных месяцев при «Весь год») — ПОЛУТОН (ACCENT_TINT +
//   ACCENT_DEEP), иначе страница заливалась оранжевым. В ДАННЫХ акцент не участвует вовсе
//   (подсветка месяцев фильтра на тренде удалена — разноцветные кружки читались как ошибка).
// - ОСНОВНЫЕ графики (динамика средней, категории) — корпоративный зелёный и его полутона:
//   это графики про сами оценки, зелёный здесь продолжает семантику «оценка», а не спорит с
//   ней. Второстепенные метрики — ТИХИЕ тёплые полутона (золото/полынь/тёплый серый), чтобы
//   различаться между собой и не подражать основным.
// - Семантика оценок 5..1 (донат, полоски, бейджи, чипы) остаётся зелёный→красный и живёт в
//   компонентах.
// - Сине-фиолетовая гамма отклонена («не наш цвет»); единственное исключение — корповый
//   $text-link, и тот сейчас не используется.
//
// Акцентная тройка живёт только в SCSS компонентов hex-литералами (в JS-код не импортируется,
// поэтому констант под неё здесь нет) — при смене сверяться с этим списком:
// - ACCENT #f1905b — активный год, подчёркивание вкладки;
// - ACCENT_DEEP #c05a1f — текст на полутоновых активных состояниях, интерфейсные ссылки;
// - ACCENT_TINT #fdeadd — заливка активных таблеток месяцев, выбранной строки рейтинга.

export const SERIES = {
    // Динамика средней оценки — главный график, корпоративный зелёный.
    averageTrend: { main: '#00a55a', lowSample: '#c8e6c9' },
    // Доля оценённых по месяцам — приглушённое золото.
    ratedShare: { main: '#cfa14f' },
    // Свёрнутый хвост «Остальные N» в top-N графиках.
    rest: '#b9b1a9',
};

// Шкала «СРЕДНЕЕ значение → цвет» для столбчатых графиков и KPI-карточек (решение владельца
// продукта, 2026-08-08): столбец говорит не только «сколько», но и «хорошо ли это».
// Пороги: >4 хорошо, 3–4 включительно «в целом ок», <3 проблема. Зелёный НАМЕРЕННО строго
// выше 4 и этим отличается от шкалы дискретных бейджей (там ★4 — хорошая оценка): средняя
// ровно 4.0 значит «у заметной части авторов есть замечания», это ещё не повод для зелёного.
//
// Цветов у баров ровно ТРИ — по одному на диапазон, отдельного «приглушённого» варианта для
// малой выборки нет (он давал четыре цвета на одном графике и ломал читаемость правила;
// решение владельца продукта, 2026-08-08). «Проблемные» диапазоны сами по себе полутоновые —
// сплошной красный/янтарный на широких барах кричал; зелёный оставлен насыщенным как награда.
// text — читаемые тёмные варианты тех же диапазонов для цифр KPI-карточек: полутоном текст
// не напишешь.
const RATING_SCALE = {
    good: { bar: '#00a55a', text: '#00a55a' },
    mid: { bar: '#f6dda9', text: '#f0a30a' },
    bad: { bar: '#f6c5c0', text: '#f44336' },
};

export function ratingTier(value) {
    if (value === null || value === undefined) {
        return null;
    }
    if (value > 4) {
        return 'good';
    }

    return value >= 3 ? 'mid' : 'bad';
}

export function ratingScaleColor(value) {
    const tier = ratingTier(value);

    return tier === null ? SERIES.rest : RATING_SCALE[tier].bar;
}

export function ratingTextColor(value) {
    const tier = ratingTier(value);

    return tier === null ? SERIES.rest : RATING_SCALE[tier].text;
}
